import {
  Button,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Spinner,
} from "@chakra-ui/react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { getEmojiDataFromNative, init } from "emoji-mart";
import { useContext, useEffect, useState } from "react";
import { BsEmojiSmile } from "react-icons/bs";
import { AccountContext } from "../../../context/AccountContextComponent";

const EmojiPicker = ({
  onEmojiSelect,
  buttonLabel,
}: {
  onEmojiSelect: (emoji: any) => void;
  buttonLabel?: string;
}) => {
  const { accountData, isLoading } = useContext(AccountContext);
  const [bannedEmojiIds, setBannedEmojiIds] = useState<string[] | undefined>(
    undefined
  );
  const [hasSetBannedEmojiIds, setHasSetBannedEmojiIds] = useState(false);

  useEffect(() => {
    const initEmojiData = async () => {
      if (!data || !accountData) return;
      await init({ data });
      const bannedEmojis = accountData?.bannedReactionEmojis ?? [];
      const allBannedPromises = bannedEmojis.map(async (emoji) => {
        const emojiData = await getEmojiDataFromNative(emoji);
        return emojiData.id;
      });
      const allBanned = await Promise.all(allBannedPromises);
      setBannedEmojiIds(allBanned);
      setHasSetBannedEmojiIds(true);
    };

    initEmojiData();
  }, [data, accountData]);

  return (
    <Popover trigger={"hover"}>
      <PopoverTrigger>
        {buttonLabel ? (
          <Button size="sm" variant="outline" leftIcon={<BsEmojiSmile />}>
            {buttonLabel}
          </Button>
        ) : (
          <IconButton
            aria-label="Emoji Picker"
            size="sm"
            variant="ghost"
            icon={<BsEmojiSmile size={"19px"} />}
          />
        )}
      </PopoverTrigger>
      <PopoverContent width="auto" maxWidth="none">
        <PopoverArrow />
        <PopoverBody>
          {isLoading && <Spinner />}
          {!isLoading && data && hasSetBannedEmojiIds && (
            <Picker
              onEmojiSelect={onEmojiSelect}
              data={data}
              theme={"light"}
              // there's a bug in emoji-mart where searching for
              // an emoji still shows the banned emoji
              exceptEmojis={bannedEmojiIds}
            />
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default EmojiPicker;
